import React, { Suspense } from "react";
import { render } from 'react-dom';
import { createStore, applyMiddleware } from 'redux'; // Creates the Central Redux Store
import { Provider } from 'react-redux'; // Makes sure the Store is connected to React
import App from './App';
import reducer from './Reducers'; // Gets the root reducer to be used by the store
import thunk from 'redux-thunk';
import { composeWithDevTools } from 'redux-devtools-extension';
import * as serviceWorker from './serviceWorker';
// import { configureFakeBackend } from './Helpers/fake-backend';
import storage from 'redux-persist/lib/storage';
import { PersistGate } from 'redux-persist/lib/integration/react';
import { persistStore, persistReducer } from 'redux-persist';
import './i18n';
import { Spin } from "react-cssfx-loading";

// configureFakeBackend();

const Loader = () => <div style={{
  width:'100%',
  height: '100%',
  display: 'flex',
  alignContent: 'center',
  alignItems: 'center',
  justifyContent: 'center',
}}><Spin width="200px" height="200px" color="#4654FB"></Spin></div>;

const persistConfig = {
  key: 'root',
  storage: storage,
};

const pReducer = persistReducer(persistConfig, reducer);

//hook up the redux devtools browser extension
export const store = createStore(pReducer,
  composeWithDevTools(
    applyMiddleware(thunk)
  )
);

const persistor = persistStore(store);

render(
  <Provider store={store}>
    <PersistGate loading={<Loader />} persistor={persistor}>
      <Suspense fallback={<Loader />}>
        <App />
      </Suspense>
    </PersistGate>
  </Provider>,
  document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
